module.exports = __webpack_public_path__ + "static/typhoon-533464720a8a1054ff8f006732da8c49.png";